<template>
  <div class="min-h-screen bg-body">
    <div class="pt-4 pb-10 max-w-4xl mx-auto">
      <!-- Header Image -->
      <router-link to="/" class="flex justify-center items-center">
        <img
          class="w-96 h-auto"
          :src="require('@/assets/IMF-header.png')"
          alt="Header"
        />
      </router-link>

      <!-- Title -->
      <div class="text-center mb-10 space-y-2">
        <h1 class="text-3xl text-zinc-700 font-bold">Terms and Conditions</h1>
        <h4 class="text-sm text-zinc-500">Last updated: October 11, 2025</h4>
      </div>
      <div class="text-zinc-500 leading-8 text-justify">Under Maintenance</div>
    </div>
  </div>
</template>
